import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);

const transformTempToDynamicDots = (temp) => {
  const { risk_summary, opportunity_summary, financial_summary } = temp;

  return [
    { value: risk_summary.total_risks, type: "Risk" },
    { value: risk_summary.high_impact_risks, type: "Risk" },
    { value: risk_summary.mitigated_risks, type: "Risk" },
    { value: risk_summary.unaddressed_risks, type: "Risk" },
    { value: opportunity_summary.total_opportunities, type: "Opportunity" },
    { value: opportunity_summary.realized_opportunities, type: "Opportunity" },
    {
      value: opportunity_summary.unrealized_opportunities,
      type: "Opportunity",
    },
    { value: opportunity_summary.archived_opportunities, type: "Opportunity" },
    // {
    //   value: parseFloat(financial_summary.quarterly_growth),
    //   type: "Opportunity",
    // },
    // { value: parseFloat(financial_summary.profit_margin), type: "Opportunity" },
    // {
    //   value: parseFloat(financial_summary.annual_revenue.replace(/[\$,]/g, "")),
    //   type: "Opportunity",
    // },
  ];
};

const PolarChart = ({ handleSelectItem, dynamicDots }) => {
  const [dotData, setDotData] = useState([]);
  const [maxValue, setMaxValue] = useState(500); // Default max value

  useEffect(() => {
    if (dynamicDots) {
      const dynamicDotsUpdated = transformTempToDynamicDots(dynamicDots);
      setDotData(dynamicDotsUpdated);

      // Calculate the maximum value from dynamicDotsUpdated
      const maxVal = Math.max(...dynamicDotsUpdated.map(dot => dot.value));
      setMaxValue(maxVal);
    }
  }, [dynamicDots]);

  const handlePointClick = (e) => {
    handleSelectItem(e.point.category);
  };

  const options = {
    chart: {
      polar: true,
      type: "line",
    },
    title: {
      text: "",
    },
    pane: {
      size: "100%",
    },
    xAxis: {
      categories: [
        "Total Risks",
        "High Impact Risks",
        "Mitigated Risks",
        "Unaddressed Risks",
        "Total Opportunities",
        "Realized Opportunities",
        "Unrealized Opportunities",
        "Archived Opportunities",
        "Quarterly Growth",
        "Profit Margin",
        "Annual Growth",
      ],
      tickmarkPlacement: "on",
      lineWidth: 0,
    },
    yAxis: {
      gridLineInterpolation: "polygon",
      lineWidth: 0,
      min: 0,
      max: maxValue, // Use the calculated max value
      tickInterval: 20,
    },
    series: [
      {
        name: "Sector Performance",
        data: dotData.map((dot, index) => ({
          y: dot.value,
          color: dot.type === "Risk" ? "#FF0000" : "#00FF00",
        })),
        marker: {
          enabled: true,
          radius: 4,
        },
        lineWidth: 0,
        pointPlacement: "on",
      },
    ],
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        point: {
          events: {
            click: handlePointClick,
          },
        },
      },
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PolarChart;
